import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { serviceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';
import { toasts } from '@/utils/toasts';

export const addService = (
  data: serviceTypes.AddServiceData
): Promise<{ service: serviceTypes.Service }> => {
  return axios.put('/services', data);
};

type AddServiceOptions = {
  department: Departments;
  onSuccess: () => void;
  config?: MutationConfig<typeof addService>;
};

export function useAddService({ config = {}, department, onSuccess }: AddServiceOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['services', department]);
      toasts.loadingToast.success('add-service', 'Service added successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('add-service', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-service', 'Adding service...');
      config.onMutate?.(...args);
    },
    mutationFn: addService,
  });
}
